import React from 'react'
import { SendExpertReferralComponent } from '#src/generated/graphql'
import { ReactMultiEmail } from 'react-multi-email'
import { IdentityConsumer } from '#src/containers/Identity'
import { toast } from 'react-toastify'
import {
  SimpleModal,
  ModalContent,
  ModalTitle,
  ModalFooter,
  Button,
  TextArea
} from '@deal/components'
import styles from './styles.css'

interface Props {
  onRequestClose: () => void
  expertId: string
}

interface State {
  emails: string[]
  note: string
}

class EmailCollectionModal extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = { emails: [], note: '' }

    this.handleNoteChanged = this.handleNoteChanged.bind(this)
  }

  public handleNoteChanged(e: React.ChangeEvent<HTMLTextAreaElement>) {
    this.setState({ note: e.target.value })
  }

  render() {
    return (
      <IdentityConsumer>
        {({ myself }) => (
          <SendExpertReferralComponent
            variables={{
              input: {
                expertId: this.props.expertId,
                referrerId: myself!.user.id,
                emails: this.state.emails,
                note: this.state.note
              }
            }}
            onCompleted={data => {
              if (data.sendExpertReferral.errors.length > 0) {
                toast.error('Could not send referral links')
              } else {
                this.props.onRequestClose()
              }
            }}
            onError={() => toast.error('Could not send referral links')}
          >
            {sendExpertReferral => (
              <SimpleModal isOpen={true} onRequestClose={this.props.onRequestClose}>
                <ModalTitle>Enter email(s)</ModalTitle>
                <ModalContent>
                  <div className={styles.textField}>
                    <ReactMultiEmail
                      placeholder="Ex. email@email.com, email@email.com"
                      className={styles.email}
                      emails={this.state.emails}
                      onChange={emails => {
                        this.setState({ emails: emails })
                      }}
                      getLabel={(
                        email: string,
                        index: number,
                        removeEmail: (index: number) => void
                      ) => {
                        return (
                          <div data-tag key={index}>
                            {email}
                            <span data-tag-handle onClick={() => removeEmail(index)}>
                              ×
                            </span>
                          </div>
                        )
                      }}
                    />
                  </div>
                  <TextArea
                    onChange={this.handleNoteChanged}
                    placeholder="Write a message..."
                    value={this.state.note}
                  />
                </ModalContent>
                <ModalFooter className={styles.footer}>
                  <Button
                    className={styles.cancel}
                    variant="secondary"
                    onClick={this.props.onRequestClose}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="black"
                    disabled={this.state.emails.length === 0}
                    onClick={() => sendExpertReferral()}
                  >
                    Send
                  </Button>
                </ModalFooter>
              </SimpleModal>
            )}
          </SendExpertReferralComponent>
        )}
      </IdentityConsumer>
    )
  }
}

export default EmailCollectionModal
